import {Outlet, useNavigate} from 'react-router-dom'
import {Header} from '@components/commons/header'
import {useMe} from '@features/user/queries/useMe.ts'
import {Spinner} from '@components/ui/spinner'
import {AvailabilityAlert} from '@features/settings/components/availability-alert'
import {AddressAlert} from '@features/settings/components/address-alert'
import {useEffect, useState} from 'react'
import {Footer} from '@components/commons/footer'
import {ScrollToAnchor} from '@utilities/scroll-to-anchor-listener'
import {useAuthStore} from '@features/user/store/store.ts'
import {AiChat} from '@features/ai-chatbot/components/ai-chat'
import {envVars} from '@/envVars.ts'
import {ImpersonateToolbar} from '@features/admin/components/impersonate-toolbar'
import {ChatBotWrapper} from '@features/chatbot/chat-bot'
import {routes} from '@utilities/constants/routes.tsx'
import {isReviewerOnly} from '@features/user/utils'
import {useIsChatbotHidden} from '@features/chatbot/hooks/useIsChatbotHidden'

export const PrivateLayout = () => {
    const meQuery = useMe({throwOnError: true})
    const adminAccessToken = useAuthStore(state => state.adminAccessToken)
    const [isAvailabilityAlertShown, setIsAvailabilityAlertShown] = useState(true)
    const navigate = useNavigate()
    const isChatbotHidden = useIsChatbotHidden()
    useEffect(() => {
        setIsAvailabilityAlertShown(true)
    }, [meQuery.data?.shootAvailable])

    useEffect(() => {
        // Reviewers don't need an address or markets, so they skip the initial setup steps.
        if (!adminAccessToken && meQuery.data && !meQuery.data?.lastMarketsUpdatedAt && !isReviewerOnly(meQuery.data)) {
            navigate(routes.MARKETS_CONFIGURATION.handle.fullPath, {replace: true})
        }
    }, [meQuery.data])

    if (meQuery.isPending) {
        return (
            <div className="h-full w-full flex justify-center items-center text-neutral-500">
                <Spinner size={40} />
            </div>
        )
    }

    return (
        <div className="grid grid-rows-[auto_1fr] overflow-hidden h-full bg-white">
            <div>
                <Header isPrivate />
                {!meQuery.data?.shootAvailable && isAvailabilityAlertShown && (
                    <AvailabilityAlert onClose={() => setIsAvailabilityAlertShown(false)} />
                )}

                {!!meQuery.data?.isInspector && !meQuery.data?.address && <AddressAlert />}
                {!!adminAccessToken && <ImpersonateToolbar />}
            </div>
            <div className="overflow-y-auto h-full grid grid-rows-[1fr_auto] grid-cols-1">
                <Outlet />
                <Footer />
                <ScrollToAnchor />
            </div>
            {!isChatbotHidden &&
                (envVars.VITE_IS_AI_CHATBOT_ENABLED && meQuery.data?.isChatbotTester ? <AiChat /> : <ChatBotWrapper />)}
        </div>
    )
}
